import { gql } from "lib/apolloClient";

export const getProductUpdatesQuery = gql`
  query getProductUpdatesV2Feed(
    $filters: ProductUpdatesFilterV2
    $after: String
    $first: Int
    $orderBy: ORDERBY_FIELD_ENUM_CMS
    $onlyNewContent: Boolean
  ) {
    cms {
      productUpdatesFeedV2(
        filters: $filters
        after: $after
        first: $first
        orderBy: $orderBy
        onlyNewContent: $onlyNewContent
      ) {
        count
        pageInfo {
          hasNextPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            title
            releaseDate
            releaseItems {
              id
              title
              redirectUrl
              betaRequestStatus
              isBeta
              isBetaRequestAllowed
              description
              version
              displaySequence
              categories {
                id
                type
                title
                group
                displaySequence
                color
              }
              module {
                id
                label
                isNewModule
                moduleKey
              }
            }
          }
          cursor
        }
      }
    }
  }
`;

export const getProductUpdatesIdAndDateQuery = gql`
  query getProductUpdatesV2Feed(
    $filters: ProductUpdatesFilterV2
    $after: String
    $first: Int
    $orderBy: ORDERBY_FIELD_ENUM_CMS
    $onlyNewContent: Boolean
  ) {
    cms {
      productUpdatesFeedV2(
        filters: $filters
        after: $after
        first: $first
        orderBy: $orderBy
        onlyNewContent: $onlyNewContent
      ) {
        count
        edges {
          node {
            id
            releaseDate
          }
        }
      }
    }
  }
`;

export const getProductUpdateModulesQuery = gql`
  query getProductUpdateModules($filters: ProductUpdatesV2ModuleFilter) {
    cms {
      modules(filters: $filters) {
        id
        label
        moduleKey
      }
    }
  }
`;

export const getProductUpdateQuery = gql`
  query getProductUpdates($id: ID!) {
    node(id: $id, type: PRODUCT_UPDATE_V2) {
      ... on ProductUpdatesV2 {
        id
        title
        releaseDate
        releaseItems {
          id
          isBeta
          title
          redirectUrl
          description
          version
          displaySequence
          categories {
            id
            type
            title
            group
            displaySequence
            color
          }
          module {
            id
            label
            isNewModule
            moduleKey
          }
          betaRequestStatus
          isBetaRequestAllowed
        }
      }
    }
  }
`;
